import { common, core, getTokens, TokensVariant, zIndex } from '@topcon/design-system';
import { getLibraryTheme } from '@topcon/tuicl-react';

import { ProjectTheme, ThemeColor } from './theme.types';

const tokens = getTokens(getLibraryTheme());

const { background, text, icon, gradient, border } = tokens;

const lightTheme: ProjectTheme = {
  example: {
    background: core.greens.green500,
    border: core.greens.green700,
  },
};

// TODO: Add dark tokens
const darkTheme: ProjectTheme = lightTheme;

const projectTheme = getLibraryTheme() === TokensVariant.dark ? darkTheme : lightTheme;

function getThemeColorValue(color: ThemeColor): string {
  if (!color) return '';

  let current: unknown = tokens;

  for (const segment of color.split('.')) {
    if (current && typeof current === 'object' && segment in current) {
      current = (current as Record<string, unknown>)[segment];
    } else {
      return '';
    }
  }

  return typeof current === 'string' ? current : String(current ?? '');
}

export { projectTheme, tokens, zIndex, common, core, getThemeColorValue };

export { background, text, icon, gradient, border };
